module.exports = __webpack_public_path__ + "static/img/photo1.6b7f0d95.jpg";